/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pleaseaddacoverimagebeforepublishing6Inputs */

const en_pleaseaddacoverimagebeforepublishing6 = /** @type {(inputs: Pleaseaddacoverimagebeforepublishing6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please add an image before publishing.`)
};

const de_pleaseaddacoverimagebeforepublishing6 = /** @type {(inputs: Pleaseaddacoverimagebeforepublishing6Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bitte füg vor dem Veröffentlichen ein Bild hinzu.`)
};

/**
* | output |
* | --- |
* | "Please add an image before publishing." |
*
* @param {Pleaseaddacoverimagebeforepublishing6Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const pleaseaddacoverimagebeforepublishing6 = /** @type {((inputs?: Pleaseaddacoverimagebeforepublishing6Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pleaseaddacoverimagebeforepublishing6Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pleaseaddacoverimagebeforepublishing6(inputs)
	return de_pleaseaddacoverimagebeforepublishing6(inputs)
});
export { pleaseaddacoverimagebeforepublishing6 as "pleaseAddACoverImageBeforePublishing" }